import React from 'react';
import followInfo from './followInfo.js';
import SubTitle from '../../components/ui/SubTitle';
import IconLink from '../../components/ui/IconLink';

function FollowInfoList() {
  return (
    <>
      <SubTitle>Follow Me</SubTitle>

      <ul className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-6 xxl:grid-cols-8 gap-3 sm:gap-5 ">
        {followInfo.map((item, index) => (
          <li key={index}>
            <IconLink iconInfo={item} />
          </li>
        ))}
      </ul>
    </>
  );
}

export default FollowInfoList;
